import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom'

const BackButton = () => {
    const history = useHistory();
    return (
        <button className='back mt-3' onClick={() => history.goBack()}>
        <FontAwesomeIcon icon={faChevronLeft} /> Back
      </button>
    )
}

export default BackButton
